import {
  ClockCircleOutlined,
  CommentOutlined,
  LinkOutlined,
  MailOutlined,
  PhoneOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { t } from 'ttag';

import useTranslation from 'common/hooks/useTranslation';
import { open as openHubSpot } from 'common/services/support';
import { SUPPORT_EMAIL, SupportPhone, SupportPhoneUrl } from 'common/services/support/types';
import Portal from 'common/types/Portal';

const KNOWLEDGE_BASE_URL = 'https://help.eventmobi.com/en/knowledge';
const SUPPORT_HOURS_URL = 'https://help.eventmobi.com/en/knowledge/eventmobi-support-hours';

const HelpDropdown = ({ firstName, lastName, email }) => {
  const { locale } = useTranslation();
  const [hubspotLoaded, setHubspotLoaded] = useState(false);

  const supportPhoneUrl = /de/.test(locale) ? SupportPhoneUrl.DE : SupportPhoneUrl.EN;
  const supportPhone = /de/.test(locale) ? SupportPhone.DE : SupportPhone.EN;

  const checkHubspot = useCallback(() => {
    const loaded = !!document.getElementById('hs-script-loader');
    setHubspotLoaded(loaded);
  }, []);

  const openChat = () => {
    openHubSpot({ firstName, lastName, email }, Portal.Experience);
  };

  const items = [
    {
      icon: <LinkOutlined />,
      label: (
        <a href={KNOWLEDGE_BASE_URL} target="_blank" rel="noopener noreferrer">
          {t`Visit our Knowledge Base`}
        </a>
      ),
    },
    {
      icon: <ClockCircleOutlined />,
      label: (
        <a href={SUPPORT_HOURS_URL} target="_blank" rel="noopener noreferrer">
          {t`Today's Support Hours`}
        </a>
      ),
    },
    {
      type: 'divider',
      style: { marginTop: 0, marginBottom: 0 },
    },
    {
      label: t`Contact Us`,
      type: 'group',
    },
    hubspotLoaded && {
      onClick: openChat,
      icon: <CommentOutlined />,
      label: t`Live Chat`,
    },
    {
      icon: <PhoneOutlined />,
      label: <a href={supportPhoneUrl}>{t`Call us ${supportPhone}`}</a>,
    },
    {
      icon: <MailOutlined />,
      label: <a href={`mailto:${SUPPORT_EMAIL}`}>{t`Email ${SUPPORT_EMAIL}`}</a>,
    },
  ].filter(Boolean);

  return (
    <Dropdown trigger={['click']} onOpenChange={checkHubspot} menu={{ items }}>
      <Button style={{ color: '#1890FF', borderColor: '#1890FF' }}>
        <QuestionCircleOutlined />
        {t`Help`}
      </Button>
    </Dropdown>
  );
};

HelpDropdown.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

export default HelpDropdown;
